export default __webpack_public_path__ + "static/media/sitlady.c516d27a.png";